import createPostedTransactions from '../views/nominal/PostedTransactionsForm';
import { IFormAction } from '../@types/entityTypes';
import React, { ReactNode, useCallback, useContext, useState } from 'react';
import ConnectedFormContext from '../components/Context/ConnectedFormContext';
import { Modal } from '@fluentui/react';

export const useViewTransactionsAction = <ActionType,>({
  actionReference,
  individualButton,
  viewTransactions: ViewTransactions,
}: {
  actionReference: ActionType;
  individualButton: boolean;
  viewTransactions: ReturnType<typeof createPostedTransactions>;
}): [action: IFormAction<ActionType>, modals: ReactNode] => {
  const { values } = useContext(ConnectedFormContext);
  const [postedTransactionsOpen, setPostedTransactionsOpen] = useState(false);
  const viewTransactionsModal = (
    <Modal isOpen={postedTransactionsOpen} onDismiss={() => setPostedTransactionsOpen(false)}>
      <ViewTransactions match={{ params: { id: values?.id } }} onClose={() => setPostedTransactionsOpen(false)} />
    </Modal>
  );

  const displayPosted = useCallback((record: any) => {
    if (record && record.documentStatus) {
      return record.documentStatus === 'POSTED';
    }
    return false;
  }, []);

  return [
    {
      actionReference: actionReference,
      key: 'viewTransactions',
      text: 'View Transactions',
      onClick: () => {
        setPostedTransactionsOpen(true);
      },
      individualButton: individualButton,
      condition: displayPosted,
    },
    <>{viewTransactionsModal}</>,
  ];
};
